export enum wizardStepConfiguratorEnum {
  MANAGER = 'MANAGER',
  SIGNER = 'SIGNER',
  USER = 'USER',
  WATCHER = 'WATCHER',
  DOCUMENT = 'DOCUMENT',
  TAG = 'TAG',
  REPLACE = 'REPLACE',
  DELETE = 'DELETE',
  ADD= 'ADD',
  CLONE = 'CLONE',
  UPDATE = 'UPDATE',
  SPROFILE = 'SPROFILE'
}
